<template>
  <div class="information">
    <div class="info-top">
      <div class="mess-con">
        <div class="mess-text">
          <div class="top-mess">{{ casedisplay.Industrydocking }}</div>
          <!-- <div class="top-message">{{ casedisplay.IndustrydockingTxt }}</div> -->
        </div>
      </div>
      <!-- <img src="@/assets/my/head.jpg" alt=""> -->
      <!-- <div class="top-mess">{{ casedisplay.Industrydocking }}</div>
      <div class="top-message">{{ casedisplay.IndustrydockingTxt }}</div> -->
    </div>
    <div class="info-content">
      <div class="info">
        <div class="info-header"></div>
        <div class="info-title" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">
          {{ casedisplay.SupplyApplication }}
          <div class="bot-bg">Supply application</div>
        </div>
      </div>
      <div class="content">
        <div class="content-text">
          <div class="title" > {{ casedisplay.SupplyApplication }}</div>
          <!-- <div class="text">汇聚顶尖人工智能解决方案，助力金砖国家企业智能升级。</div> -->
          <div class="text"> {{ casedisplay.SupplyApplicationTxt }}</div>
          <div class="btn" @click="go">
            <span> {{ casedisplay.SupplySubmission }}</span>
            <img src="@/assets/img/title-more.png" alt="">
          </div>
        </div>
        <div class="content-photo"><img src="@/assets/img/dock1.png" alt=""></div>
      </div>
      <div class="bottom-box">
        <div class="info">
          <div class="info-header"></div>
          <div class="info-title" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">
            {{ casedisplay.DemandApplication }}
            <div class="bot-bg">Request Application</div>
          </div>
        </div>
        <div class="content">
          <div class="content-photo"><img src="@/assets/img/dock2.png" alt=""></div>
          <div class="content-text">
          <div class="title">{{ casedisplay.DemandApplication }}</div>
          <!-- <div class="text">寻求顶尖人工智能解决方案，赋能金砖国家政府及企业智能化发展。</div> -->
          <div class="text">{{ casedisplay.DemandApplicationTxt }}</div>
          <div class="btn" @click="go">
            <span>{{ casedisplay.DemandSubmission }}</span>
            <img src="@/assets/img/title-more.png" alt="">
          </div>
        </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndustryDock',
  computed:{
    casedisplay(){
      return this.$t('casedisplay')
    }
  },
  methods: {
    go () {
      this.$router.push('applicationProcess')
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  width: 100%;
  .info-top {
    .mess-con {
      height: 180px;
      max-width: 1200px;
      margin: 0 auto;
      background: url('@/assets/my/head.jpg') no-repeat;
      background-size: 100% 100%;
      .mess-text {
        max-width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 0px 0 0 0;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 20px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
  }
  .info-content {
    width: 100%;
    box-sizing: border-box;
    padding: 60px 0 0px 0;
    // background: #F5F7FA;
    .info {
      .info-header {
        width: 84px;
        height: 4px;
        background: linear-gradient( 270deg, #1D3E95 0%, #4840C2 100%);
        border-radius: 4px 4px 4px 4px;
        margin: 0 auto 22px;
      }
      .info-title {
        margin: 0 auto;
        margin-top: 22px;
        height: 40px;
        font-family: Inter;
        font-weight: 400;
        font-size: 36px;
        color: #080808;
        line-height: 40px;
        position: relative;
        .bot-bg {
          height: 50px;
          font-family: Inter;
          font-weight: 700;
          font-size: 36px;
          color: rgba(194, 194, 194, 0.12);
          line-height: 50px;
          text-align: center;
          position: absolute;
          top: 5px;
          left: 50%;
          transform: translate(-50%, 0);
          white-space: nowrap;
        }
      }
    }
    .content {
      max-width: 1200px;
      margin: 50px auto 50px;
      display: flex;
      .content-photo {
        width: 580px;
      }
      .content-text {
        width: 620px;
        height: 436px;
        box-sizing: border-box;
        padding: 64px 30px 64px 50px ;
        // background: #FFFFFF;
        background: #F5F7FA !important;
        .title {
          height: 45px;
          font-family: Inter;
          font-weight: 500;
          font-size: 24px;
          color: #333640;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .text {
          font-family: Inter;
          font-weight: 400;
          font-size: 16px;
          color: #61656C;
          line-height: 24px;
          text-align: justify;
          font-style: normal;
          text-transform: none;
        }
        .btn {
          
          margin-top: 190px;
          height: 44px;
          background: #1B3E92;
          border-radius: 0px 0px 0px 0px;
          font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 14px;
            height: 14px;
            margin-left: 16px;
          }
        }
      }
      img {
        width: 580px;
      }
    }
    .bottom-box {
      width: 100%;
      padding: 10px 0 1px 0;
      background: #fff;
      .content-text {
        background: #F5F7FA !important;
        padding: 64px 50px 64px 30px !important;
      }
    }
  }
}
@media (min-width: 600px) and (max-width: 1040px) {
  .content {
    justify-content: center;
  }
  .content-photo {
    display: none !important;
  }
}
@media (max-width: 600px) {
  .info-top {
    .top-mess {
      top: -16% !important;
      left: 15% !important;
      font-size: 20px !important;
    }
    .top-message {
      // top: 40% !important;
      left: 15% !important;
      margin-top: 0px !important;
      font-size: 14px !important;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-form {
    white-space: normal !important;
    text-align: left;
    &>div {
      margin-top: 8px;
    }
  }
  .left-btn > div {
    margin-right: 10px !important;
  }
  .trend-input {
    display: unset !important;
  }
  .page-text {
    width: 100px !important;
  }
  .content-photo {
    display: none !important;
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .mess-con {
    height: 150px !important;
    padding: 0 2vw;
    box-sizing: border-box;
  }
}
.bot-tit-en {
  font-weight: 600 !important;
}
</style>
